/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Table } from "antd";
import { blogimg10, imagesend, pdficon, pdficon3, pdficon4, plusicon, refreshicon, searchnormal, blogimg12,
     blogimg2, blogimg4, blogimg6, blogimg8 } from '../imagepath';
import { onShowSizeChange, itemRender } from '../Pagination';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import config from '../../config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { DatePicker } from 'antd';
import Header from '../Header';
import Sidebar from '../Sidebar';

const AppoinmentList = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [activeTab, setActiveTab] = useState('upcoming');
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [formData, setFormData] = useState({
    appointment_id: '',
    patient_name: '',
    doctor_id: '',
    date: '',
    time: '',
  });

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Fetch appointments from API
  const fetchAppointments = async () => {
    try {
      const userId = localStorage.getItem('userUUID');
      if (!userId) {
        toast.error("User ID is missing");
        return;
      }

      const response = await fetch(
        `${config.API_URL}get_user_appointments.php?user_id=${userId}`
      );
      const result = await response.json();

      if (result.status === "success") {
        // Add status field based on date comparison
        const now = new Date();
        const appointmentsWithStatus = result.appointments.map(appointment => {
          const [year, month, day] = appointment.date.split('-');
          const [hours, minutes] = appointment.time.split(':');
          const appointmentDate = new Date(year, month - 1, day, hours, minutes);
          
          return {
            ...appointment,
            status: appointmentDate <= now ? 'completed' : 'upcoming'
          };
        });
        setAppointments(appointmentsWithStatus);
      } else {
        toast.error(result.message || "No appointments found");
      }
    } catch (error) {
      console.error("Error fetching appointments:", error);
      toast.error("Failed to fetch appointments");
    } finally {
      setLoading(false);
    }
  };

  // Filter appointments based on active tab
  const filterAppointments = () => {
    const now = new Date();
    return appointments.filter(appointment => {
      try {
        const [year, month, day] = appointment.date.split('-');
        const [hours, minutes] = appointment.time.split(':');
        const appointmentDate = new Date(year, month - 1, day, hours, minutes);
        
        return activeTab === 'upcoming' 
          ? appointmentDate > now 
          : appointmentDate <= now;
      } catch (error) {
        console.error('Error parsing appointment date/time:', error);
        return false;
      }
    }).sort((a, b) => {
      try {
        const [aYear, aMonth, aDay] = a.date.split('-');
        const [aHours, aMinutes] = a.time.split(':');
        const dateA = new Date(aYear, aMonth - 1, aDay, aHours, aMinutes);
        
        const [bYear, bMonth, bDay] = b.date.split('-');
        const [bHours, bMinutes] = b.time.split(':');
        const dateB = new Date(bYear, bMonth - 1, bDay, bHours, bMinutes);
        
        return activeTab === 'upcoming' ? dateA - dateB : dateB - dateA;
      } catch (error) {
        console.error('Error sorting appointments:', error);
        return 0;
      }
    });
  };

  // Handle search
  const handleSearch = (e) => {
    setSearchText(e.target.value.toLowerCase());
  };

  // Filter appointments based on search text
  const filteredAppointments = filterAppointments().filter(appointment => {
    return (
      (appointment.patient_name || '').toLowerCase().includes(searchText) ||
      (appointment.doctor_name || '').toLowerCase().includes(searchText) ||
      (appointment.institution_name || '').toLowerCase().includes(searchText) ||
      (appointment.date || '').toLowerCase().includes(searchText) ||
      (appointment.time || '').toLowerCase().includes(searchText)
    );
  });

  // Format time for display
  const formatTime = (timeString) => {
    return new Date(`2000-01-01T${timeString}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  // Open edit modal with appointment data
  const openEditModal = (appointment, e) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedAppointment(appointment);
    setFormData({
      appointment_id: appointment.appointment_id,
      patient_name: appointment.patient_name,
      doctor_id: appointment.doctor_id,
      date: appointment.date,
      time: appointment.time,
    });
    setShowEditModal(true);
  };

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${config.API_URL}update_appointment.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.status === 'success') {
        toast.success('Appointment updated successfully');
        setShowEditModal(false);
        await fetchAppointments();
      } else {
        toast.error(result.message || 'Failed to update appointment');
      }
    } catch (error) {
      console.error('Error updating appointment:', error);
      toast.error('Failed to update appointment');
    }
  };

  // Table columns
  const columns = [
    {
      title: "Patient Name",
      dataIndex: "patient_name",
      render: (text, record) => (
        <h2 className="profile-image">
          <Link to="#" className="avatar avatar-sm me-2">
            <img
              className="avatar-img rounded-circle"
              src={blogimg2}
              alt="User Image"
            />
          </Link>
          <Link to="#">{record.patient_name}</Link>
        </h2>
      ),
      sorter: (a, b) => (a.patient_name || '').localeCompare(b.patient_name || '')
    },
    {
      title: "Doctor",
      dataIndex: "doctor_name",
      render: (text) => `Dr. ${text}`,
      sorter: (a, b) => (a.doctor_name || '').localeCompare(b.doctor_name || '')
    },
    {
      title: "Hospital",
      dataIndex: "institution_name",
      render: (text) => text || 'N/A',
      sorter: (a, b) => (a.institution_name || '').localeCompare(b.institution_name || '')
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      title: "Time",
      dataIndex: "time",
      sorter: (a, b) => a.time.localeCompare(b.time),
      render: (time) => formatTime(time)
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span className={`badge ${status === 'completed' ? 'bg-success' : 'bg-primary'}`}>
          {status}
        </span>
      ),
      sorter: (a, b) => (a.status || '').localeCompare(b.status || '')
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text, record) => (
        <div className="text-end">
          {activeTab === 'upcoming' && (
            <div className="dropdown dropdown-action">
              {/* <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v" />
              </Link> */}
              {/* <div className="dropdown-menu dropdown-menu-end">
                <button
                  className="dropdown-item"
                  onClick={(e) => openEditModal(record, e)}
                >
                  <i className="far fa-edit me-2" />
                  Edit
                </button>
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete_patient"
                >
                  <i className="fa fa-trash-alt m-r-5"></i> Delete
                </Link>
              </div> */}
            </div>
          )}
        </div>
      ),
    },
  ];

  // Fetch data on component mount
  useEffect(() => {
    fetchAppointments();
  }, []);

  return (
    <>
      <Header />
      <Sidebar id='menu-item4' id1='menu-items4' activeClassName='appoinment-list'/>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Appointment</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <FeatherIcon icon="chevron-right"/>
                  </li>
                  <li className="breadcrumb-item active">Appointment List</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  {/* Table Header */}
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Appointment List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search here"
                                  value={searchText}
                                  onChange={handleSearch}
                                />
                                <Link className="btn">
                                  <img src={searchnormal} alt="Search" />
                                </Link>
                              </form>
                            </div>
                            <div className="add-group d-flex align-items-center">
                              <div className="btn-group me-2" role="group" aria-label="Appointment Tabs">
                                <button
                                  type="button"
                                  className={`btn ${activeTab === 'upcoming' ? 'btn-primary' : 'btn-light'}`}
                                  onClick={() => setActiveTab('upcoming')}
                                  aria-pressed={activeTab === 'upcoming'}
                                  style={{ minWidth: '100px' }}
                                >
                                  Upcoming
                                </button>
                                <button
                                  type="button"
                                  className={`btn ${activeTab === 'history' ? 'btn-primary' : 'btn-light'}`}
                                  onClick={() => setActiveTab('history')}
                                  aria-pressed={activeTab === 'history'}
                                  style={{ minWidth: '100px' }}
                                >
                                  History
                                </button>
                              </div>
                              {/* <Link
                                to="/addappoinments"
                                className="btn btn-primary add-pluss ms-2"
                                title="Add Appointment"
                              >
                                <img src={plusicon} alt="Add" />
                              </Link> */}
                              {/* <Link
                                to="#"
                                className="btn btn-primary doctor-refresh ms-2"
                                onClick={fetchAppointments}
                                title="Refresh"
                              >
                                <img src={refreshicon} alt="Refresh" />
                              </Link> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <Link to="#" className="me-2">
                          <img src={pdficon} alt="PDF" />
                        </Link>
                        <Link to="#" className="me-2">
                          <img src={pdficon3} alt="PDF" />
                        </Link>
                        <Link to="#">
                          <img src={pdficon4} alt="PDF" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Table Header */}
                  <div className="table-responsive">
                    {loading ? (
                      <div className="text-center py-4">Loading appointments...</div>
                    ) : filteredAppointments.length > 0 ? (
                      <Table
                        pagination={{
                          total: filteredAppointments.length,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onShowSizeChange: onShowSizeChange,
                          itemRender: itemRender,
                        }}
                        columns={columns}
                        dataSource={filteredAppointments}
                        rowSelection={rowSelection}
                        rowKey={(record) => record.appointment_id}
                      />
                    ) : (
                      <div className="text-center py-4 text-muted">
                        No {activeTab === 'upcoming' ? 'upcoming' : 'past'} appointments found
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Appointment Modal */}
        <div
          className={`modal fade ${showEditModal ? 'show d-block' : ''}`}
          id="editAppointmentModal"
          role="dialog"
          style={{ display: showEditModal ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Appointment</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>Appointment Details</h4>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-6">
                      <div className="form-group local-forms">
                        <label>
                          Patient Name <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="patient_name"
                          value={formData.patient_name}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-6">
                      <div className="form-group local-forms">
                        <label>
                          Doctor <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={selectedAppointment?.doctor_name || ''}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-6">
                      <div className="form-group local-forms cal-icon">
                        <label>
                          Date <span className="login-danger">*</span>
                        </label>
                        <DatePicker
                          className="form-control datetimepicker"
                          onChange={(date, dateString) =>
                            setFormData((prev) => ({
                              ...prev,
                              date: dateString,
                            }))
                          }
                          value={formData.date ? moment(formData.date) : null}
                          suffixIcon={null}
                          format="YYYY-MM-DD"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-6">
                      <div className="form-group local-forms">
                        <label>
                          Time <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="time"
                          name="time"
                          value={formData.time}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="doctor-submit text-end">
                        <button
                          type="submit"
                          className="btn btn-primary submit-form me-2"
                        >
                          Update
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary cancel-form"
                          onClick={() => setShowEditModal(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Delete Modal */}
        <div id="delete_patient" className="modal fade delete-modal" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="Delete" width={50} height={46} />
                <h3>Are you sure want to delete this appointment?</h3>
                <div className="m-t-20">
                  <Link to="#" className="btn btn-white me-2" data-bs-dismiss="modal">
                    Close
                  </Link>
                  <button type="submit" className="btn btn-danger">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppoinmentList;